import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import amelie from "../../assets/images/speakers/amelie.jpg";
function Amelie() {
    return (
        <>
            <div class="header">
                <div class="header-content">
                    <div class="left">
                        <div class="header-box">
                            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
                        </div>
                        <p>September 12, 2025 - September 13, 2025</p>
                        <p>University of Maryland, College Park</p>
                        <p>Stamp Student Union</p>
                    </div>
                    <div className="right">
                        <img src={logo} className="logo" alt="Q^3 Logo" />
                    </div>
                </div>
            </div>
            <div className="speaker-box">
                <div className="speaker-photo">
                    <img src={amelie} alt="Amelie Wang" className="speakerspic"/>
                </div>
                <div className="speaker-content">
                    <h1>Amelie Wang</h1>
                    <h2>Student @ John Hopkins University</h2>

                </div>
            </div>
            <div className="speaker-content">
                <p className="p">Amelie is a multidisciplinary creator whose work bridges the worlds of physics and the arts.
                    She is a rising senior studying physics at Johns Hopkins University, with research experience in soft
                    condensed matter and experimental cosmology. Passionate about sharing complex ideas in engaging ways, she tel
                    ls stories through music, animation, comics, and theatre. Since 2017, she has been deeply involved
                    in musical theatre, including a national tour of The Sound of Music across 46 cities. In 2024,
                    she interned at the Shanghai Astronomy Museum as a summer presenter, and she is currently a presenter
                    at the Maryland Science Center, delivering ideas about constellations and the universe. Her artistic wor
                    k often draws from surrealism, environmental science, and physics, combining imagination with
                    inquiry to spark curiosity in others.
                </p>
            </div>
        </>
    );
}


export default Amelie;